import dayjs from 'dayjs';

interface ChangeTarget {
  name: string;
  value: any;
  type?: string;
  checked?: boolean;
}

type ResolveRef = (ref: any) => any;

const clampToBounds = (val: number, field: any, resolveRef: ResolveRef): number => {
  if (field.hasOwnProperty('max') && field.hasOwnProperty('min') && val !== null) {
    const fieldMax = typeof field.max === 'string' ? resolveRef(field.max) : field.max;
    val = val > fieldMax ? fieldMax : val;
    val = val < field.min ? field.min : val;
  }
  return val;
};

export const coerceFieldValue = ({ name, value, type, checked }: ChangeTarget, field: any, resolveRef: ResolveRef): any => {
  let val: any = value;

  if (name.startsWith('cleaning_packages.') && type === 'number') {
    val = val === '' ? 0 : Number(value);
    val = clampToBounds(val, field, resolveRef);
  } else if (type === 'number') {
    val = val === '' ? null : Number(value);
    val = clampToBounds(val, field, resolveRef);
  }

  if (type === 'array') {
    val = value.split(',').map((x: string) => Number(x));
    val = val.length && val[0] !== 0 ? val : null;
  }
  if (type === 'sarray') {
    val = value.split(',').map((item: string) => ({ date: dayjs(item) }));
    val = val.length && val[0] !== '' ? val : null;
  }
  if (type === 'checkbox') {
    val = checked;
  }
  if (type === 'switch') {
    val = checked;
  }

  return val;
};
